export enum ProjectRoutesNamesEnum {
  projectCreation = 'project-creation',
  address = 'address',
  applicant = 'applicant',
  certification = 'certification'
}
